// npm

// css
import '../../scss/pages/page-entry.scss';

// libs

// utils
import RecruitFoundation from '../_utils/RecruitFoundation';
RecruitFoundation();

document.addEventListener('DOMContentLoaded', () => {
	// メールアドレス（確認）
	function escapeHtml(text) {
		const map = {
			'&': '&amp;',
			'<': '&lt;',
			'>': '&gt;',
			'"': '&quot;',
			"'": '&#039;',
			'\n': '<br/>',
		};

		return text.replace(/[&<>"'\n]/g, function (m) {
			return map[m];
		});
	}

	const email = document.getElementById('js-form-email');
	/**
	 * @type {HTMLInputElement} emailInput
	 */
	const emailInput = email.querySelector('input');
	const emailCheck = email.querySelector('.js-email-check');

	emailInput.addEventListener('input', () => {
		if (emailInput.value) {
			emailCheck.textContent = escapeHtml(emailInput.value);
		} else {
			emailCheck.textContent = 'sample@kinokuni-j.co.jp';
		}
	});

	document.addEventListener(
		'wpcf7mailsent',
		function () {
			setTimeout(() => {
				location.href = '../entry-thanks/';
			}, 1000);
		},
		false
	);
});

window.addEventListener('load', () => {});
